import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Image, X } from "lucide-react";
import { ServiceImage } from "@/types/user";

interface GallerySectionProps {
  images: ServiceImage[];
  isEditing: boolean;
  onAddImage: (image: { url: string; description: string }) => void;
  onRemoveImage: (id: string) => void;
}

export function GallerySection({
  images,
  isEditing,
  onAddImage,
  onRemoveImage
}: GallerySectionProps) {
  const [newImage, setNewImage] = useState({ url: "", description: "" });

  const handleAddImage = () => {
    if (newImage.url && newImage.description) {
      onAddImage(newImage);
      setNewImage({ url: "", description: "" });
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Image className="h-5 w-5" />
          <h2 className="text-xl font-semibold">Galeria de Serviços</h2>
        </div>
      </div>

      {isEditing && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            placeholder="URL da imagem"
            value={newImage.url}
            onChange={(e) => setNewImage({ ...newImage, url: e.target.value })}
          />
          <Input
            placeholder="Descrição da imagem"
            value={newImage.description}
            onChange={(e) => setNewImage({ ...newImage, description: e.target.value })}
          />
          <Button onClick={handleAddImage} className="md:col-span-2">
            Adicionar Imagem
          </Button>
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {images.map((image) => (
          <div key={image.id} className="relative group aspect-square">
            <img
              src={image.url}
              alt={image.description}
              className="w-full h-full object-cover rounded-lg"
            />
            <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity rounded-lg flex items-center justify-center">
              <p className="text-white text-sm p-2 text-center">
                {image.description}
              </p>
              {isEditing && (
                <button
                  onClick={() => onRemoveImage(image.id)}
                  className="absolute top-2 right-2 text-white hover:text-red-500"
                >
                  <X className="h-5 w-5" />
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}